export default "__VITE_ASSET__CEpwYNvm__"